import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";
import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {FinalizeIssueCommand} from "../commands/finalize-issue.command";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";

@injectable()
@transformer({
    source: FinalizeIssueCommand,
    target: `dto`
})
export class FinalizeIssueCommandToDtoTransformer extends AbstractCommandToDtoTransformer<string> {

    protected async toDTO(uid: string): Promise<DataTransferObject> {
        return Promise.resolve(<DataTransferObject>{ uid: uid });
    }

}